import axios from 'axios';

interface MetaExchangeRate {
  venta: string;
  compra: string;
  compra_date: string;
  venta_date: string;
  garantia: string;
  licence: string;
}

export interface DollarRate {
  purchase: number;
  sale: number;
  date: string;
}

export async function getDollarValue(): Promise<DollarRate> {
  try {
    const response = await axios.get<MetaExchangeRate>(
      'https://apis.gometa.org/tdc/tdc.json'
    );
    
    const apiDate = response.data.compra_date || response.data.venta_date;
    const formattedDate = new Date(apiDate).toLocaleDateString('es-CR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });

    return {
      purchase: parseFloat(response.data.compra),
      sale: parseFloat(response.data.venta),
      date: formattedDate,
    };
  } catch (error) {
    console.error('Error fetching exchange rate:', error);
    throw new Error('Exchange rate could not be obtained', { cause: error });
  }
}